<template>
  <button class="switch" :class="{ active : switchState }" @click="switchStatus()">
    <div class="indicator"></div>
  </button>
</template>

<script>
export default {
  name: 'ElementSwitch',
  props: [
    'initialState',
  ],
  data: function () {
    return {
      switchState: this.initialState,
    }
  },
  methods: {
    switchStatus() {
      this.switchState = !this.switchState;
      this.$emit('switchStatus', this.switchState);
    },
  },
}
</script>


<style scoped>
.switch {
  background-color: #ddd;
  border-radius: 5px;
  height: 36px;
  padding: 4px;
  position: relative;
  transition: 0.3s all ease;
  width: 70px;
}
.switch .indicator {
  background-color: #fff;
  border-radius: 3px;
  height: 28px;
  left: 4px;
  position: absolute;
  top: 4px;
  transition: 0.3s all ease;
  width: 32px;
}
.switch.active {
  background-color: #4CD964;
  justify-content: flex-end;
}
.switch.active .indicator {
  transform: translateX(30px);
}
</style>
